import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiFileText } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getTerms } from '../services/dataService';
import RichTextRenderer from '../components/RichTextRenderer';

const TermsPage = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const data = await getTerms();
        setTerms(data);
      } catch (error) {
        console.error('Failed to load terms:', error);
        setTerms({ title: 'Terms of Service', content: 'Terms content not available at the moment.' });
      } finally {
        setLoading(false);
      }
    };

    loadTerms();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading terms...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Header Section */}
      <section className="bg-emerald-900 py-24 text-white relative text-center">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-8 border border-white/20">
              <SafeIcon icon={FiFileText} className="w-10 h-10 text-emerald-400" />
            </div>
            <h1 className="text-5xl lg:text-7xl font-black mb-6">Terms of <span className="text-emerald-400">Service</span></h1>
            <p className="text-xl text-emerald-100/70">Please read our terms and conditions carefully before using our services.</p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-2xl shadow-xl p-8 lg:p-12"
          >
            {terms && (
              <>
                <RichTextRenderer content={terms.content} />
                {terms.last_updated && (
                  <div className="mt-12 pt-8 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                      Last updated: {new Date(terms.last_updated).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                  </div>
                )}
              </>
            )}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;